$("td:has(input)").css("padding", "1px");